import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cx } from '../../../internal/cx.js';
import { CopyButton } from '../../actions/copy-button/index.js';
import { DescriptionValueClamp } from './description-list.clamp.js';
/** Key/value facts on detail pages (owner, stage, created, …). */
export const DescriptionList = forwardRef(function DescriptionList({ columns = 2, layout = 'stacked', className, ...rest }, ref) {
    return (_jsx("dl", { ref: ref, ...rest, "data-columns": columns, "data-layout": layout, className: cx('mn-dl', className) }));
});
function isEmpty(value) {
    return value === null || value === undefined || value === false || value === '';
}
export const DescriptionItem = forwardRef(function DescriptionItem({ term, children, wide, className, placeholder, emptyLabel = 'Not set', copyable, copyLabel, truncate, expandLabel = 'Show more', collapseLabel = 'Show less', }, ref) {
    const empty = isEmpty(children);
    const copyText = typeof copyable === 'string'
        ? copyable
        : copyable && (typeof children === 'string' || typeof children === 'number')
            ? String(children)
            : null;
    const lines = truncate === true ? 1 : typeof truncate === 'number' ? truncate : 0;
    let value;
    if (empty) {
        value =
            placeholder !== undefined ? (placeholder) : (_jsxs(_Fragment, { children: [_jsx("span", { "aria-hidden": "true", children: "\u2014" }), _jsx("span", { className: "mn-visually-hidden", children: emptyLabel })] }));
    }
    else if (lines > 0) {
        value = (_jsx(DescriptionValueClamp, { lines: lines, expandLabel: expandLabel, collapseLabel: collapseLabel, children: children }));
    }
    else {
        value = children;
    }
    return (_jsxs("div", { ref: ref, className: cx('mn-dl__item', className), "data-wide": wide || undefined, "data-empty": empty || undefined, children: [_jsx("dt", { className: "mn-dl__term", children: term }), _jsx("dd", { className: "mn-dl__value", children: copyText !== null && !empty ? (_jsxs("span", { className: "mn-dl__copy-row", children: [_jsx("span", { className: "mn-dl__copy-value", children: value }), _jsx(CopyButton, { value: copyText, iconOnly: true, size: "xs", label: copyLabel ?? (typeof term === 'string' ? `Copy ${term}` : 'Copy'), className: "mn-dl__copy" })] })) : (value) })] }));
});
//# sourceMappingURL=description-list.js.map